import {
  FETCH_VISIBLE_OVERVIEW__ERROR,
  FETCH_VISIBLE_OVERVIEW__REQUEST,
  FETCH_VISIBLE_OVERVIEW__SUCCESS,
} from "../../actionTypes";
import { TemplatesActions } from "../../types";

// Kdyby bylo víc kategorií, možná dát zvlášť do adresáře + combineReducer...
const initialState = false;

const isFetchingAll = (
  state: boolean = initialState,
  action: TemplatesActions
): boolean => {
  switch (action.type) {
    case FETCH_VISIBLE_OVERVIEW__REQUEST:
      return true;

    case FETCH_VISIBLE_OVERVIEW__SUCCESS:
    case FETCH_VISIBLE_OVERVIEW__ERROR:
      return false;

    default:
      return state;
  }
};

export default isFetchingAll;
